module.exports = __webpack_public_path__ + "static/img/bg_btn2.dacc741.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/bg_btn2.png
// module id = jz3N
// module chunks = 4